<script lang="ts" context="module">
    export type HeaderType = 'A' | 'B' | 'C' | 'Show' | 'library';
    export type TextAlignment = 'leading' | 'trailing' | 'centered' | null;
</script>

<script lang="ts">
    export let headerType: HeaderType;
    export let displaySeparator: boolean = false;
    export let textAlignment: TextAlignment = null;
    export let isAriaHidden: boolean = false;
</script>

<!--
    TODO: rdar://99985062 (JMOTW: Better handling of spacing elements under hero artwork)
-->
<div
    class="header-nav"
    class:header-nav--with-separator={displaySeparator}
    class:header-nav--header-type-a={headerType === 'A'}
    class:header-nav--library-header={headerType === 'library'}
    data-testid="header-component-model"
    aria-hidden={isAriaHidden}
>
    <h1
        class="header-nav__heading"
        class:header-nav__heading--centered={textAlignment === 'centered'}
    >
        <slot />
    </h1>
    {#if $$slots.action}
        <div class="header-nav__action">
            <slot name="action" />
        </div>
    {/if}
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .header-nav {
        padding-top: $spacerC;
        padding-bottom: 0.05px; // Disable margin-collapse
        display: grid;
        grid-template-columns: 1fr auto; // Collapse second column if there's no action
        align-items: end;
        margin-inline-start: var(--bodyGutter);
        margin-inline-end: var(--bodyGutter);

        // Contextual menu for Actions
        :global(.more-button) {
            --contextMenuCircleFillOverride: var(--systemQuinary);
            --contextMenuEllipsisFillOverride: var(--keyColor);
            --contextMenuCircleHoverFill: var(--systemQuinary);
            --contextMenuEllipsisHoverFill: var(--keyColor);
        }
    }

    .header-nav--with-separator {
        padding-bottom: 8px;
        border-bottom: var(--keyline-border-style);
    }

    .header-nav--library-header {
        $facehole-margin-mobile: 25px;
        $facehole-margin-compact-player: 15px;
        $facehole-margin-full-player: 20px;
        height: 38px;
        padding-top: 0; // Remove top padding for library headers

        // TODO: rdar://104052943 (Spacers between page sections are not to spec)
        // The section that follows currently has default padding added to it;
        // this negative margin "undoes" that margin so we get the correct
        // spacing. We should adjust/remove this when section spacers are updated.
        margin-bottom: -12px;

        // Align text and accessory buttons to vertical center, rather than end
        align-items: center;

        // Adjust end margin of library header to align with edge of facehole in web chrome.
        // This margin changes width based on the web chrome and viewport width.
        margin-inline-end: #{$facehole-margin-mobile};

        @media (--sidebar-visible) {
            margin-inline-end: #{$facehole-margin-compact-player};
        }

        @media (--small) {
            margin-inline-end: #{$facehole-margin-full-player};
        }

        .header-nav__heading {
            color: var(--systemPrimary);
            font: var(--title-3-emphasized);
        }

        :global(svg) {
            fill: var(--systemSecondary);
        }
    }

    .header-nav__heading {
        grid-row: 1;
        grid-column: 1;
        color: var(--systemPrimary);
        font: var(--header-emphasized);
    }

    .header-nav__heading--centered {
        text-align: center;
        margin-inline-end: 0;
    }

    .header-nav__action {
        grid-row: 1;
        grid-column: 2;
        inset-inline-end: 0;
    }
</style>
